module.exports = __webpack_public_path__ + "static/media/calendar-plus.52f1767e.svg";